export const airports = [
  { city: "Tokyo", country: "Japan", code: "NRT" },
  { city: "Tokyo", country: "Japan", code: "HND" },
  { city: "Singapore", country: "Singapore", code: "SIN" },
  { city: "Bangkok", country: "Thailand", code: "BKK" },
  { city: "Hong Kong", country: "China", code: "HKG" },
  { city: "Seoul", country: "South Korea", code: "ICN" },
  { city: "Dubai", country: "UAE", code: "DXB" },
  { city: "Delhi", country: "India", code: "DEL" },
  { city: "Mumbai", country: "India", code: "BOM" },
  { city: "Jakarta", country: "Indonesia", code: "CGK" },
  { city: "Kuala Lumpur", country: "Malaysia", code: "KUL" },
  { city: "Karachi", country: "Pakistan", code: "KHI" },
  { city: "Lahore", country: "Pakistan", code: "LHE" },
  { city: "Islamabad", country: "Pakistan", code: "ISB" },
  { city: "Beijing", country: "China", code: "PEK" },
  { city: "Shanghai", country: "China", code: "PVG" },
  { city: "Guangzhou", country: "China", code: "CAN" },
  { city: "Istanbul", country: "Turkey", code: "IST" },
  { city: "Doha", country: "Qatar", code: "DOH" },
  { city: "Taipei", country: "Taiwan", code: "TPE" },
  { city: "Manila", country: "Philippines", code: "MNL" },
  { city: "Riyadh", country: "Saudi Arabia", code: "RUH" },
  { city: "Jeddah", country: "Saudi Arabia", code: "JED" },
  { city: "Amman", country: "Jordan", code: "AMM" },
  { city: "Damascus", country: "Syria", code: "DAM" },
  { city: "Beirut", country: "Lebanon", code: "BEY" },
  { city: "Tel Aviv", country: "Israel", code: "TLV" },
  { city: "Hanoi", country: "Vietnam", code: "HAN" },
  { city: "Ho Chi Minh City", country: "Vietnam", code: "SGN" },
  { city: "Phnom Penh", country: "Cambodia", code: "PNH" },
  { city: "Kathmandu", country: "Nepal", code: "KTM" },
  { city: "Dhaka", country: "Bangladesh", code: "DAC" },
  { city: "Colombo", country: "Sri Lanka", code: "CMB" },
  { city: "Male", country: "Maldives", code: "MLE" },
  { city: "Muscat", country: "Oman", code: "MCT" },
  { city: "Abu Dhabi", country: "UAE", code: "AUH" },
  { city: "Tehran", country: "Iran", code: "IKA" },
  { city: "London", country: "United Kingdom", code: "LHR" },
  { city: "London", country: "United Kingdom", code: "LGW" },
  { city: "Paris", country: "France", code: "CDG" },
  { city: "Amsterdam", country: "Netherlands", code: "AMS" },
  { city: "Frankfurt", country: "Germany", code: "FRA" },
  { city: "Munich", country: "Germany", code: "MUC" },
  { city: "Madrid", country: "Spain", code: "MAD" },
  { city: "Barcelona", country: "Spain", code: "BCN" },
  { city: "Rome", country: "Italy", code: "FCO" },
  { city: "Moscow", country: "Russia", code: "SVO" },
  { city: "Moscow", country: "Russia", code: "DME" },
  { city: "Zurich", country: "Switzerland", code: "ZRH" },
  { city: "Geneva", country: "Switzerland", code: "GVA" },
  { city: "Vienna", country: "Austria", code: "VIE" },
  { city: "Dublin", country: "Ireland", code: "DUB" },
  { city: "Lisbon", country: "Portugal", code: "LIS" },
  { city: "Copenhagen", country: "Denmark", code: "CPH" },
  { city: "Oslo", country: "Norway", code: "OSL" },
  { city: "Stockholm", country: "Sweden", code: "ARN" },
  { city: "Helsinki", country: "Finland", code: "HEL" },
  { city: "Warsaw", country: "Poland", code: "WAW" },
  { city: "Prague", country: "Czech Republic", code: "PRG" },
  { city: "Athens", country: "Greece", code: "ATH" },
  { city: "Brussels", country: "Belgium", code: "BRU" },
  { city: "Budapest", country: "Hungary", code: "BUD" },
  { city: "Kiev", country: "Ukraine", code: "KBP" },
  { city: "Reykjavik", country: "Iceland", code: "KEF" },
  { city: "Manchester", country: "United Kingdom", code: "MAN" },
  { city: "Milan", country: "Italy", code: "MXP" },
  { city: "Dusseldorf", country: "Germany", code: "DUS" },
  { city: "New York", country: "USA", code: "JFK" },
  { city: "New York", country: "USA", code: "LGA" },
  { city: "Los Angeles", country: "USA", code: "LAX" },
  { city: "Chicago", country: "USA", code: "ORD" },
  { city: "Toronto", country: "Canada", code: "YYZ" },
  { city: "Vancouver", country: "Canada", code: "YVR" },
  { city: "Montreal", country: "Canada", code: "YUL" },
  { city: "Mexico City", country: "Mexico", code: "MEX" },
  { city: "Atlanta", country: "USA", code: "ATL" },
  { city: "Dallas/Fort Worth", country: "USA", code: "DFW" },
  { city: "Denver", country: "USA", code: "DEN" },
  { city: "Miami", country: "USA", code: "MIA" },
  { city: "Seattle", country: "USA", code: "SEA" },
  { city: "Houston", country: "USA", code: "IAH" },
  { city: "San Francisco", country: "USA", code: "SFO" },
  { city: "Cancun", country: "Mexico", code: "CUN" },
  { city: "Las Vegas", country: "USA", code: "LAS" },
  { city: "Orlando", country: "USA", code: "MCO" },
  { city: "Washington, D.C.", country: "USA", code: "IAD" },
  { city: "Boston", country: "USA", code: "BOS" },
  { city: "Havana", country: "Cuba", code: "HAV" },
  { city: "Kingston", country: "Jamaica", code: "KIN" },
  { city: "San José", country: "Costa Rica", code: "SJO" },
  { city: "São Paulo", country: "Brazil", code: "GRU" },
  { city: "Rio de Janeiro", country: "Brazil", code: "GIG" },
  { city: "Buenos Aires", country: "Argentina", code: "EZE" },
  { city: "Santiago", country: "Chile", code: "SCL" },
  { city: "Bogotá", country: "Colombia", code: "BOG" },
  { city: "Lima", country: "Peru", code: "LIM" },
  { city: "Quito", country: "Ecuador", code: "UIO" },
  { city: "Caracas", country: "Venezuela", code: "CCS" },
  { city: "Montevideo", country: "Uruguay", code: "MVD" },
  { city: "La Paz", country: "Bolivia", code: "LPB" },
  { city: "Asunción", country: "Paraguay", code: "ASU" },
  { city: "Johannesburg", country: "South Africa", code: "JNB" },
  { city: "Cairo", country: "Egypt", code: "CAI" },
  { city: "Nairobi", country: "Kenya", code: "NBO" },
  { city: "Casablanca", country: "Morocco", code: "CMN" },
  { city: "Addis Ababa", country: "Ethiopia", code: "ADD" },
  { city: "Lagos", country: "Nigeria", code: "LOS" },
  { city: "Cape Town", country: "South Africa", code: "CPT" },
  { city: "Algiers", country: "Algeria", code: "ALG" },
  { city: "Tunis", country: "Tunisia", code: "TUN" },
  { city: "Accra", country: "Ghana", code: "ACC" },
  { city: "Dakar", country: "Senegal", code: "DKR" },
  { city: "Entebbe", country: "Uganda", code: "EBB" },
  { city: "Dar es Salaam", country: "Tanzania", code: "DAR" },
  { city: "Sydney", country: "Australia", code: "SYD" },
  { city: "Melbourne", country: "Australia", code: "MEL" },
  { city: "Auckland", country: "New Zealand", code: "AKL" },
  { city: "Brisbane", country: "Australia", code: "BNE" },
  { city: "Perth", country: "Australia", code: "PER" },
  { city: "Christchurch", country: "New Zealand", code: "CHC" },
  { city: "Fiji", country: "Fiji", code: "NAN" },
  { city: "Wellington", country: "New Zealand", code: "WLG" },
  { city: "Port Moresby", country: "Papua New Guinea", code: "POM" },
  { city: "Tahiti", country: "French Polynesia", code: "PPT" },
  { city: "Villa Las Estrellas", country: "Antarctica", code: "SCRM" },
  { city: "Troll Station", country: "Antarctica", code: "ENOE" },
  { city: "McMurdo Station", country: "Antarctica", code: "NZIR" },
];
